
export default function formatDate(dateInput) {
  if (!dateInput) return "";

  // Range support
  if (typeof dateInput === "string" && dateInput.includes(" - ")) {
    const [start, end] = dateInput.split(" - ");

    return `${formatSingleDate(start)} - ${formatSingleDate(end)}`;
  }

  return formatSingleDate(dateInput);
}

function formatSingleDate(dateString) {
  if (!dateString) return "";

  const date = new Date(dateString);

  // Invalid date protection
  if (isNaN(date.getTime())) return "—";

  const formattedDay = date.getDate().toString().padStart(2, "0");

  const formattedMonth = date.toLocaleString("en-US", {
    month: "short",
  });

  const formattedYear = date.getFullYear();

  return `${formattedDay} ${formattedMonth} ${formattedYear}`;
}